import { db } from '../FirebaseLibrary';

export const createGamesReference = () => {
    return db.collection('games');
};

export const createGameReference = (gameId: string) => {
    return createGamesReference().doc(gameId);
};

export const fetchGameFirestoreAPI = (gameId: string) => {
    return createGameReference(gameId).get();
};

export const fetchGamesFirestoreAPI = (teamId: string) => {
    return createGamesReference().where('teamId', '==', teamId).orderBy('timeOfGame')
        .get();
};

export const fetchLimitedPreviousGamesFirestoreAPI = (teamId: string, count: number) => {
    return createGamesReference().where('teamId', '==', teamId).where('timeOfGame', '<=', new Date())
        .orderBy('timeOfGame', 'desc')
        .limit(count)
        .get();
};

export const fetchLimitedScheduledGamesFirestoreAPI = (teamId: string, count: number) => {
    return createGamesReference().where('teamId', '==', teamId).where('timeOfGame', '>=', new Date())
        .orderBy('timeOfGame')
        .limit(count)
        .get();
};

export const fetchLimitedPreviousGamesOfSeasonFirestoreAPI = (teamId: string, seasonId: string, count: number) => {
    return createGamesReference().where('teamId', '==', teamId).where('timeOfGame', '<=', new Date()).where('seasonId', '==', seasonId)
        .orderBy('timeOfGame', 'desc')
        .limit(count)
        .get();
};

export const fetchLimitedScheduledGamesOfSeasonFirestoreAPI = (teamId: string, seasonId: string, count: number) => {
    return createGamesReference().where('teamId', '==', teamId).where('timeOfGame', '>=', new Date()).where('seasonId', '==', seasonId)
        .orderBy('timeOfGame')
        .limit(count)
        .get();
};

export const fetchGamesofLeagueAndSeasonFirestoreAPI = (teamId: string, seasonId: string, leagueId: string) => {
    return createGamesReference().where('teamId', '==', teamId).where('timeOfGame', '<=', new Date()).where('seasonId', '==', seasonId)
        .where('leagueId', '==', leagueId)
        .where('status', '==', 'finished')
        .orderBy('timeOfGame')
        .get();
};
